import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle() {
    const [light, setLight] = useState(() => {
        try { return localStorage.getItem("ssc_theme") === "light"; } catch (e) { return false; }
    });

    const toggle = () => {
        const next = !light;
        document.documentElement.classList.toggle("light", next);
        try { localStorage.setItem("ssc_theme", next ? "light" : "dark"); } catch (e) {}
        setLight(next);
    };

    return (
        <Button variant="ghost" size="icon" className="rounded-full" data-testid="theme-toggle"
            onClick={toggle} aria-label={light ? "Switch to dark mode" : "Switch to light mode"}>
            {light ? <Moon className="h-5 w-5 text-primary" /> : <Sun className="h-5 w-5 text-primary" />}
        </Button>
    );
}
